import SHA256 from 'crypto-js/sha256';
import { NormalizePhoneToTikTokFormat, NormalizePhoneToDefaultFormat } from 'helpers/phoneHelper';

export function hashEmailWithCryptoJS(email: string): string {
    return SHA256(email.trim().toLowerCase()).toString();
}

export function hashPhoneNumberWithTikTokNormalization(phone: string): string {
    const normalizedPhone = NormalizePhoneToTikTokFormat(phone);

    return SHA256(normalizedPhone).toString();
}

export function hashPhoneNumberWithDefaultNormalization(phone: string): string {
    const normalizedPhone = NormalizePhoneToDefaultFormat(phone);

    return SHA256(normalizedPhone).toString();
}